import { partnerEnabledForExpertUniversity, useExpertUniversityConfiguration } from "@expert/expert-university";
import { NotificationCenter } from "@expert/solve-tools";
import { Group, useMatches } from "@mantine/core";

import { env } from "@/config";
import { PartnerSelectionMenu } from "@/expert-university/components/PartnerSelectionMenu";
import { AgentStatus, FeedbackButton, Profile } from "@/header";
import { usePartnerFeatureConfigured } from "@/partner/usePartnerConfig";
import { useActiveTask, useAgentSdk, useAgentStore } from "@/sdk";

import EvlConnectionStatus from "../evl/EvlConnectionStatus";
import { useExpertUniversityOverrides } from "../workspace/hooks/useExpertUniversityOverrides";

export function HeaderControls() {
    const { allowedPartners, trainingPartner, mostRecentSessionId } = useExpertUniversityConfiguration();
    const currentActivity = useAgentStore((state) => state.activity);
    let { feedback, feedbackType } = usePartnerFeatureConfigured();
    const feedbackOverrides = useExpertUniversityOverrides() || undefined;

    const activeTask = useActiveTask();
    const sdk = useAgentSdk();

    const isTraining = currentActivity === "Training" || currentActivity === "Residency";
    const isExpertUniversityEnabled = isTraining && partnerEnabledForExpertUniversity(trainingPartner, env.channel);
    if (isExpertUniversityEnabled && feedbackOverrides?.feedback) {
        feedback = feedbackOverrides.feedback;
        feedbackType = feedbackOverrides.feedbackType;
    }
    const buttonGroupGap = useMatches({
        base: "xs",
        md: "sm",
        lg: "md",
    });

    return (
        <Group wrap="nowrap" align="center" pr="lg" gap="lg">
            {allowedPartners.length > 1 && isExpertUniversityEnabled && !activeTask && <PartnerSelectionMenu />}
            <Group gap="0" id="header-status-group" wrap="nowrap" align="center">
                {sdk.requiresEvl && env.channel !== "chat" && <EvlConnectionStatus />}
            </Group>
            <Group gap={buttonGroupGap} id="header-controls-group" wrap="nowrap" align="center">
                <NotificationCenter />
                {feedback && feedbackType && (
                    <FeedbackButton
                        feedbackType={feedbackType}
                        isTraining={isExpertUniversityEnabled}
                        sessionID={isExpertUniversityEnabled ? mostRecentSessionId : undefined}
                    />
                )}
                <AgentStatus />
                <Profile isProdMode={env.isProdMode} commitHash={env.commitHash} />
            </Group>
        </Group>
    );
}
